(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel-stage.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel-stage.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const tickets = svs.tickets;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const TicketWithPodiumShadow = tickets.next.components.TicketWithPodiumShadow;
const TicketCarousel = tickets.next.components.ticketCarousel.TicketCarousel;
const getClassName = function () {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(' ');
};
const getTicketAspectRatioValue = ticketInfo => {
  const width = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width);
  const height = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height);
  if (!width || !height) {
    return null;
  }
  return width / height;
};
const getTicketAspectRatio = ticketInfo => {
  const aspectRatioValue = getTicketAspectRatioValue(ticketInfo);
  if (!aspectRatioValue) {
    return null;
  }
  return "".concat(ticketInfo.width, " / ").concat(ticketInfo.height);
};
const isWideTicket = ticketInfo => {
  const aspectRatioValue = getTicketAspectRatioValue(ticketInfo);
  return aspectRatioValue > 1;
};
const getPickVisualScale = () => {
  var _window$matchMedia, _window;
  if (typeof window === 'undefined') {
    return 1;
  }
  return (_window$matchMedia = (_window = window).matchMedia) !== null && _window$matchMedia !== void 0 && (_window$matchMedia = _window$matchMedia.call(_window, '(min-width: 1024px)')) !== null && _window$matchMedia !== void 0 && _window$matchMedia.matches ? 0.96 : 0.94;
};
const getTicketStageStyle = ticketInfo => {
  const width = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width);
  const height = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height);
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return null;
  }
  const isWide = width > height;
  const playMaxWidth = isWide ? width : Math.min(width * 1.12, 430);
  return {
    '--ticket-stage-natural-width': "".concat(width, "px"),
    '--ticket-stage-natural-height': "".concat(height, "px"),
    '--ticket-stage-mobile-max-width': "".concat(Math.min(width, 390), "px"),
    '--ticket-stage-play-max-width': "".concat(playMaxWidth, "px"),
    '--ticket-stage-play-mobile-max-width': "".concat(Math.min(playMaxWidth, 430), "px")
  };
};
const getCenteredAvailableWidth = _ref => {
  var _boundsNode$getBoundi, _document$documentEle;
  let boundsNode = _ref.boundsNode,
    node = _ref.node;
  if (typeof window === 'undefined' || !node) {
    return 0;
  }
  const rect = node.getBoundingClientRect();
  const boundsRect = boundsNode === null || boundsNode === void 0 || (_boundsNode$getBoundi = boundsNode.getBoundingClientRect) === null || _boundsNode$getBoundi === void 0 ? void 0 : _boundsNode$getBoundi.call(boundsNode);
  const viewportWidth = window.innerWidth || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientWidth) || 0;
  const boundsLeft = (boundsRect === null || boundsRect === void 0 ? void 0 : boundsRect.left) || 0;
  const boundsRight = (boundsRect === null || boundsRect === void 0 ? void 0 : boundsRect.right) || viewportWidth;
  const centerX = rect.left + rect.width / 2;
  const sideWidth = Math.max(Math.min(centerX - boundsLeft, boundsRight - centerX), 0);
  return sideWidth * 2;
};
const TicketPodiumStageFrame = _ref2 => {
  let before = _ref2.before,
    children = _ref2.children,
    className = _ref2.className,
    growAreaClassName = _ref2.growAreaClassName,
    growAreaRef = _ref2.growAreaRef,
    holderClassName = _ref2.holderClassName,
    placeholderClassName = _ref2.placeholderClassName,
    placeholderRef = _ref2.placeholderRef,
    placeholderStyle = _ref2.placeholderStyle,
    stageRef = _ref2.stageRef,
    ticketInfo = _ref2.ticketInfo,
    _ref2$opacity = _ref2.opacity,
    opacity = _ref2$opacity === void 0 ? 0.7 : _ref2$opacity;
  const ticketAspectRatio = getTicketAspectRatio(ticketInfo);
  const ticketStageStyle = getTicketStageStyle(ticketInfo);
  const resolvedPlaceholderStyle = _objectSpread(_objectSpread({}, ticketAspectRatio ? {
    aspectRatio: ticketAspectRatio
  } : null), placeholderStyle);
  return React.createElement("div", {
    className: getClassName('ticket-stage-frame', isWideTicket(ticketInfo) ? 'ticket-stage-frame--wide' : null, className),
    ref: stageRef,
    style: ticketStageStyle
  }, React.createElement("div", {
    className: getClassName('tickets-card-holder tickets-card-holder--play ticket-stage-frame__holder', holderClassName)
  }, before && React.createElement("div", {
    className: "ticket-stage-frame__overlay"
  }, before), React.createElement("div", {
    className: getClassName('tickets-card-grow-area tickets-card-grow-area--play ticket-stage-frame__grow-area', growAreaClassName),
    ref: growAreaRef
  }, React.createElement("div", {
    className: getClassName('tickets-card-placeholder tickets-card-placeholder--play ticket-stage-frame__placeholder', placeholderClassName),
    ref: placeholderRef,
    style: resolvedPlaceholderStyle
  }, children)), React.createElement("div", {
    className: "ticket-stage-frame__podium"
  }, React.createElement(TicketWithPodiumShadow, {
    aspectRatio: ticketAspectRatio,
    opacity: opacity,
    translateY: "12%"
  }))));
};
const useTicketCarouselStageSize = _ref3 => {
  let ticketInfo = _ref3.ticketInfo;
  const growAreaRef = useRef(null);
  const placeholderRef = useRef(null);
  const stageRef = useRef(null);
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    availableWidth = _useState2[0],
    setAvailableWidth = _useState2[1];
  const _useState3 = useState({
      width: 0,
      height: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    panelSize = _useState4[0],
    setPanelSize = _useState4[1];
  useEffect(() => {
    if (!(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.width) || !(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.height)) {
      return undefined;
    }
    if (!growAreaRef.current || !placeholderRef.current) {
      return undefined;
    }
    const updateAvailableWidth = () => {
      const nextAvailableWidth = getCenteredAvailableWidth({
        boundsNode: stageRef.current,
        node: placeholderRef.current
      });
      setAvailableWidth(previousAvailableWidth => {
        if (previousAvailableWidth === nextAvailableWidth) {
          return previousAvailableWidth;
        }
        return nextAvailableWidth;
      });
    };
    const removeContainedSizeObserver = svs.tickets.next.utils.utils.observeContainedSize({
      container: growAreaRef.current,
      target: placeholderRef.current,
      width: ticketInfo.width,
      height: ticketInfo.height,
      onUpdate: _ref4 => {
        let width = _ref4.width,
          height = _ref4.height;
        setPanelSize(previousSize => {
          if (previousSize.width === width && previousSize.height === height) {
            return previousSize;
          }
          return {
            width,
            height
          };
        });
        updateAvailableWidth();
      }
    });
    updateAvailableWidth();
    window.addEventListener('resize', updateAvailableWidth);
    let resizeObserver = null;
    if (window.ResizeObserver && placeholderRef.current) {
      resizeObserver = new window.ResizeObserver(updateAvailableWidth);
      resizeObserver.observe(placeholderRef.current);
      if (stageRef.current) {
        resizeObserver.observe(stageRef.current);
      }
    }
    return () => {
      removeContainedSizeObserver();
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener('resize', updateAvailableWidth);
    };
  }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height, ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width]);
  return {
    availableWidth,
    growAreaRef,
    panelSize,
    placeholderRef,
    stageRef
  };
};
const TicketCarouselStage = _ref5 => {
  var _ticketInfo$skins;
  let _ref5$cssSelectors = _ref5.cssSelectors,
    cssSelectors = _ref5$cssSelectors === void 0 ? 'ticket-with-podium-image' : _ref5$cssSelectors,
    initialSelectedNumber = _ref5.initialSelectedNumber,
    onPick = _ref5.onPick,
    onSelectedNumberChange = _ref5.onSelectedNumberChange,
    pickRequest = _ref5.pickRequest,
    ticketInfo = _ref5.ticketInfo,
    ticketType = _ref5.ticketType;
  const _useTicketCarouselSta = useTicketCarouselStageSize({
      ticketInfo
    }),
    availableWidth = _useTicketCarouselSta.availableWidth,
    growAreaRef = _useTicketCarouselSta.growAreaRef,
    panelSize = _useTicketCarouselSta.panelSize,
    placeholderRef = _useTicketCarouselSta.placeholderRef,
    stageRef = _useTicketCarouselSta.stageRef;
  const panelTicketType = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type) || ticketType;
  const hasTicketInfo = Boolean(ticketInfo);
  const _useState5 = useState(0.7),
    _useState6 = _slicedToArray(_useState5, 2),
    podiumOpacity = _useState6[0],
    setPodiumOpacity = _useState6[1];
  useEffect(() => {
    if (!hasTicketInfo || !panelSize.width || !panelSize.height) {
      return;
    }
    svs.tickets.next.utils.utils.stashTicketPickSize({
      height: panelSize.height,
      ticketType: panelTicketType,
      visualWidth: panelSize.width * getPickVisualScale(),
      width: panelSize.width
    });
  }, [hasTicketInfo, panelSize.height, panelSize.width, panelTicketType]);
  if (!ticketInfo) {
    return null;
  }
  return React.createElement(TicketPodiumStageFrame, {
    className: "ticket-carousel-stage",
    growAreaRef: growAreaRef,
    holderClassName: "ticket-carousel-stage__anchor",
    opacity: podiumOpacity,
    placeholderRef: placeholderRef,
    stageRef: stageRef,
    ticketInfo: ticketInfo
  }, React.createElement("div", {
    className: "ticket-carousel-stage__carousel"
  }, React.createElement(TicketCarousel, {
    availableWidth: availableWidth,
    cssSelectors: cssSelectors,
    image: ticketInfo === null || ticketInfo === void 0 || (_ticketInfo$skins = ticketInfo.skins) === null || _ticketInfo$skins === void 0 || (_ticketInfo$skins = _ticketInfo$skins[0]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image,
    initialSelectedNumber: initialSelectedNumber,
    onPick: onPick,
    onPodiumOpacityChange: setPodiumOpacity,
    onSelectedNumberChange: onSelectedNumberChange,
    panelHeight: panelSize.height,
    panelWidth: panelSize.width,
    pickRequest: pickRequest,
    skins: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.skins,
    ticketType: ticketType,
    variations: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.variations
  })));
};
setGlobal('svs.tickets.next.components.ticketCarousel.TicketPodiumStageFrame', TicketPodiumStageFrame);
setGlobal('svs.tickets.next.components.ticketCarousel.TicketCarouselStage', TicketCarouselStage);

 })(window);